var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCross = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    d: "m3.49398,7.04819c-0.12048,-0.24096 -0.08344,-0.38386 -0.24096,-0.60241c-0.09963,-0.13823 -0.12048,-0.24096 -0.24096,-0.36145c-0.12048,-0.12048 -0.12048,-0.24096 -0.24096,-0.36145c-0.12048,-0.12048 -0.12048,-0.24096 -0.24096,-0.24096l-0.12048,0",
    id: "svg_8",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "svg_9",
    y2: 16.20482,
    x2: 16.86747,
    y1: 3.43373,
    x1: 3.37349,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#EC6A4E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "svg_11",
    y2: 18.49397,
    x2: 18.19277,
    y1: 3.43374,
    x1: 1.3253,
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#EC6A4E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "svg_12",
    y2: 3.19277,
    x2: 18.31325,
    y1: 18.61446,
    x1: 1.68675,
    strokeWidth: 1.5,
    fill: "none"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCross, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cross.3c1838d6.svg";
export { ForwardRef as ReactComponent };